import { render, staticRenderFns } from "./ConfettiFlag.vue?vue&type=template&id=1a29eac8&scoped=true"
import script from "./ConfettiFlag.vue?vue&type=script&lang=ts"
export * from "./ConfettiFlag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a29eac8",
  null
  
)

export default component.exports